import { getKeyValues } from '/@/modules/core/app/helpers/ObjectHelper';

export default class Enum {
  constructor(model: Partial<Enum> = {}) {
    Object.assign(this, model);
  }

  static getValues<U extends Enum>(this: { new (): U }): U[] {
    return Object.values(this);
  }

  static getKeys(): string[] {
    return Object.keys(this);
  }

  static getByKey<U extends Enum & { key: unknown }>(
    this: { new (): U },
    key: U['key']
  ): U | undefined;

  static getByKey<U extends Enum, K extends keyof U>(
    this: { new (): U },
    key: U[K],
    prop: K
  ): U | undefined;

  static getByKey<U extends Enum, K extends keyof U>(
    this: { new (): U },
    key: U[K],
    prop?: K
  ): U | undefined {
    const propKey: keyof U = prop ?? ('key' as keyof U);

    // @ts-ignore
    return this.getValues().find((item: unknown) => {
      const value: unknown = (item as U)[propKey];
      return value === key;
    }) as U;
  }

  static getKeyValues<U extends Enum>(): { [key: string]: U } {
    return getKeyValues(this);
  }

  static getValuesByProp<U extends Enum>(prop: keyof U): string[] {
    return this.getValues().flatMap((item: unknown) => {
      const value: unknown = (item as U)[prop];
      return value;
    }) as string[];
  }

  static getParentKeyFromSubKey(
    subKey: Enum & {
      key: string;
    }
  ): string {
    return subKey.key.split('_')[0];
  }
}
